import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './theme.css';
import '@flaticon/flaticon-uicons/css/all/all.css';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
